import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Producto } from '../../../_models/producto';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NavService } from '../../../_services/_nav.service';
import { forkJoin } from 'rxjs';
import { ProductoFormaDesembolso } from '../../../_models/producto-forma-desembolso';
import { FormaDesembolso } from '../../../_models/forma-desembolso';
import { FormaDesembolsoService } from '../../../_services/forma-desembolso.service';
import { ProductoFormaDesembolsoService } from '../../../_services/producto-forma-desembolso.service';
import { ProductoFormaDesembolsoConvenioComponent } from './forma-desembolso-convenio/producto-forma-desembolso-convenio.component';

@Component( {
  selector: 'app-producto-forma-desembolso',
  templateUrl: 'producto-forma-desembolso.component.html'
} )

export class ProductoFormaDesembolsoComponent implements OnInit {

  @Input() producto: Producto;
  lisFormaDesembolso: SelectItem[] = [];
  lisFormaDesembolsoTodos: FormaDesembolso[] = [];
  carInformacionInicial = true;
  lisProductoFormaDesembolsoTodos: ProductoFormaDesembolso[] = [];
  lisProductoFormaDesembolso: ProductoFormaDesembolso[] = [];
  formulario: FormGroup;
  submitted = false;
  columnas: any[];
  verPcfdModal = false;

  @ViewChild(`pfdc`, { static: true })
  pfdc: ProductoFormaDesembolsoConvenioComponent;

  constructor( private forDesembolsoServicio: FormaDesembolsoService,
               private proFormaDesembolsoServicio: ProductoFormaDesembolsoService,
               private navServicio: NavService,
               private fb: FormBuilder,
               private conServicio: ConfirmationService ) {
  }

  ngOnInit(): void {
    this.columnas = [
      { field: 'formaDesembolso', header: this.navServicio.buscarMensaje( 'FORMADESEMBOLSO.LBL_TIPOESPECIE' ), sort: false },
      { field: 'porcentaje', header: this.navServicio.buscarMensaje( 'FORMADESEMBOLSO.LBL_PORCENTAJE' ), sort: false },
      { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];

    forkJoin( this.forDesembolsoServicio.listadoHabilitado(),
      this.proFormaDesembolsoServicio.listadoPorProducto( this.producto.idProducto ) ).subscribe( ( [ formaDesembolso, proForDes ] ) => {
      this.lisFormaDesembolsoTodos = formaDesembolso;
      this.lisProductoFormaDesembolsoTodos = proForDes;
      this.cargarProducoDesembolso();
      this.cargarFormaDesembolso();
      this.cargarFormulario();
      this.carInformacionInicial = false;
    } );
  }

  cargarFormaDesembolso() {
    this.lisFormaDesembolso = [];
    this.lisFormaDesembolsoTodos.map( ( s: FormaDesembolso ) => {
      if ( !this.lisProductoFormaDesembolso.find( x => x.idFormaDesembolso === s.idFormaDesembolso ) ) {
        this.lisFormaDesembolso.push( { label: s.nombre, value: s.idFormaDesembolso } );
      }
    } );
  }

  cargarProducoDesembolso() {
    this.lisProductoFormaDesembolso = this.lisProductoFormaDesembolsoTodos.filter( x => x.indicadorHabilitado );
  }


  cargarFormulario() {
    this.formulario = this.fb.group( {
      idProducto: [ this.producto.idProducto, [ Validators.required ] ],
      idFormaDesembolso: [ null, [ Validators.required ] ],
      indicadorHabilitado: [ true, [ Validators.required ] ],
    } );
  }

  get f() {
    return this.formulario.controls;
  }

  onSubmit() {
    this.submitted = true;
    if ( this.formulario.valid ) {
      this.carInformacionInicial = true;
      const formulario = this.formulario.value;
      const exiRegistro = this.lisProductoFormaDesembolsoTodos.find( x => x.idFormaDesembolso === formulario.idFormaDesembolso );
      if ( exiRegistro ) {
        exiRegistro.indicadorHabilitado = true;
        this.proFormaDesembolsoServicio.actualizar( exiRegistro ).subscribe( registro => {
          this.salir();
        } );
      } else {
        this.proFormaDesembolsoServicio.crear( formulario ).subscribe( registro => {
          formulario.idProductoFormaDesembolso = registro.idProductoFormaDesembolso;
          const a = this.lisFormaDesembolsoTodos.find( x => x.idFormaDesembolso === registro.idFormaDesembolso );
          if ( a ) {
            formulario.formaDesembolso = a.nombre;
            formulario.porcentaje = a.porcentaje;
          }
          this.lisProductoFormaDesembolsoTodos.push( formulario );
          this.salir();
        } );
      }
    }
  }

  salir() {
    this.cargarProducoDesembolso();
    this.cargarFormaDesembolso();
    this.formulario.reset();
    this.f.idProducto.setValue( this.producto.idProducto );
    this.f.indicadorHabilitado.setValue( true );
    this.submitted = false;
    this.carInformacionInicial = false;
    this.navServicio.setMesage( 1 );
  }

  inhabilitar( registro: ProductoFormaDesembolso ) {
    this.conServicio.confirm( {
      message: this.navServicio.buscarMensaje( 'MSG_INHABILITAR' ),
      header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
      icon: 'fa fa-question-circle',
      key: 'forma-desembolso',
      accept: () => {
        this.carInformacionInicial = true;
        registro.indicadorHabilitado = false;
        this.proFormaDesembolsoServicio.actualizar( registro ).subscribe( regActualizado => {
          this.cargarProducoDesembolso();
          this.cargarFormaDesembolso();
          this.navServicio.setMesage( 2 );
          this.carInformacionInicial = false;
        } );
      },
      reject: () => {
      }
    } );
  }

  configurar( row ) {
    this.pfdc.cargarProductosConveniosFormasDesembolso( row.idProductoFormaDesembolso );
    this.verPcfdModal = true;
  }

  verDatatable( event: boolean ) {
    this.verPcfdModal = false;
  }
}
